import React, { useRef, useEffect } from "react";
import videoFile from "../../components/face.mp4";
import audioFile from "../../components/inquire.m4a";

function InquiryRemoval() {
  const videoRef = useRef(null);
  const audioRef = useRef(null);

  const handlePlay = () => {
    if (audioRef.current) {
      audioRef.current.play();
    }
  };

  useEffect(() => {
      const playMedia = async () => {
        if (videoRef.current && audioRef.current) {
          try {
            await videoRef.current.play();
            await audioRef.current.play();
          } catch (error) {
            console.log("Autoplay blocked by browser, user interaction needed.");
          }
        }
      };
      playMedia();
    }, []);

  return (
    <div className="container">
      <div className="banner" onClick={handlePlay}>
        <video
          ref={videoRef}
          src={videoFile}
          autoPlay
          loop
          muted
          playsInline
          className="video"
        />
      </div>

      <audio ref={audioRef} src={audioFile} />

      <div className="container_body">
        <div className="course">
          <h1>Inquiry Removal</h1>
          <p>
            Say Goodbye to Hard Inquiries! 📝❌ Join Quashawn White as he
            reveals the methods for removing inquiries from your credit report
            the right way. Learn why clearing unnecessary inquiries can boost
            your score and increase your chances of getting approved for
            funding. It’s time to clean up your credit and unlock new
            possibilities! 💳🚀 #InquiryRemoval
          </p>
          <p>EQUIFAX INQUIRY REMOVAL SCRIPT</p>
          <a href="https://docs.google.com/document/d/16igKhAWc_6MxYLPWjyHXUEajaw2Xv_McVHBu2eaai_4/edit?tab=t.0">
            https://docs.google.com/document/d/16igKhAWc_6MxYLPWjyHXUEajaw2Xv_McVHBu2eaai_4/edit?tab=t.0
          </a>
        </div>
      </div>
    </div>
  );
}

export default InquiryRemoval;
